import React, { useState, useMemo, useEffect } from "react";
import FilterComponent from "../Layout/FilterComponent";
import SearchExportComponent from "../Layout/SearchExportComponent";
import SalesTable from "./SalesTable";
import Pagination from "../Layout/Pagination";
import { getDistributorSale } from "../../services/salesService";
import { COMPANIES, DOCTORS } from "../../constants/fetchData";
import { getDistributorNames, getExportData } from "../../Common/functions";

const DistributorSale = ({
  // data,
  // currentPage,
  // totalPages,
  // totalCount,
  // setCurrentPage,
  handleViewAction,
  userRole,

}) => {
  const [filters, setFilters] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Manage which headers are visible
  const [visibleHeaders, setVisibleHeaders] = useState([
    "distributor_name",
    "sales_count",
    "leads_count",
    "revenue",
    "action",
  ]);

  const filterFields = [
    {
      type: "dropdown",
      label: "Distributor name",
      id: "distributorName",
      options:
        userRole === "super_admin"
          ? COMPANIES
          : getDistributorNames().map((item) => ({ value: item, label: item })),
    },
    {
      type: "dropdown",
      label: "Tracking status",
      id: "trackingStatus",
      options: [
        { value: "Demo", label: "Demo" },
        { value: "Lead", label: "Lead" },
        { value: "Sale", label: "Sale" },
        { value: "NoSale", label: "No Sale" },
      ],
    },
    {
      type: "dropdown",
      label: "Doctor name",
      id: "doctorName",
      options: DOCTORS,
    },
    {
      type: "dropdown",
      label: "Product group",
      id: "productGroup",
      options: [
        { value: "group1", label: "Group 1" },
        { value: "group2", label: "Group 2" },
      ],
    },
    {
      type: "dropdown",
      label: "Choose team",
      id: "chooseTeam",
      options: [
        { value: "Avana_Employee", label: "Internal User" },
        { value: "Distributor", label: "Distributor" },
        { value: "Distributor_Admin", label: "Distributor Admin" },
      ],
    },
    { type: "date", label: "From Date", id: "fromDate" },
    { type: "date", label: "To Date", id: "toDate" },
  ];

  const handleApplyFilters = (appliedFilters) => setFilters(appliedFilters);
  const handleResetFilters = () => setFilters({});
  const handleSearch = (term) => setSearchTerm(term);
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);
  // const handleExport = () => console.log("Exporting data:", processedData);

  // // Memoized filtered data
  // const processedData = useMemo(() => {
  //   return data.filter((item) => {
  //     const matchesSearch =
  //       !searchTerm ||
  //       item.distributor_name.toLowerCase().includes(searchTerm.toLowerCase());
  //     const matchesFilters = Object.entries(filters).every(
  //       ([key, value]) => !value || item[key] === value
  //     );
  //     return matchesSearch && matchesFilters;
  //   });
  // }, [data, searchTerm, filters]);

  // All available table headers
  const tableHeaders = [
    { label: "Distributor", value: "distributor_name" },
    { label: "Total Sales", value: "sales_count" },
    { label: "Total Lead", value: "leads_count" },
    { label: "Tracking Status", value: "trackingStatus" },
    { label: "Revenue", value: "revenue" },
    { label: "Action", value: "action" },
  ];

  function getTotalPages(totalItems, itemsPerPage) {
    if (itemsPerPage <= 0) return 0; // avoid division by zero
    return Math.ceil(totalItems / itemsPerPage);
  }

  const getSalesDetails = async () => {
    setLoading(true);
    setData([]);
    const payload = {
      category: "sales tracking",
      page_size: itemsPerPage,
      page_number: currentPage,
      start_date: filters.fromDate,
      end_date: filters.toDate,
    }
    if (userRole !== "super_admin") {
      if (filters.distributorName) {
        payload.distributor_names = [filters.distributorName];
      } else {
        payload.distributor_names = getDistributorNames();
      }
      
    } else {
      payload.distributor_names = filters.distributorName && [filters.distributorName];
    }
    // Remove null, undefined, and empty string values
    const cleanedPayload = Object.fromEntries(
      Object.entries(payload).filter(([key, value]) => {
        return value !== null && 
              value !== undefined && 
              value !== "" && 
              // value !== [null] && 
              value !== " ".trim(); // Also removes whitespace-only strings
      })
    );
    try {
      const result = await getDistributorSale(cleanedPayload);

      if (result?.data) {
        setData(result.data.response_data);
        setCurrentPage(result.data.page_number);
        setTotalCount(result.data.total_items);
        setTotalPages(getTotalPages(result.data.total_items, itemsPerPage));
      } else {
        console.error("Unexpected response format:", result);
      }
    } catch (error) {
      console.error("Error fetching sales details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSalesDetails();
  }, [itemsPerPage, currentPage, filters]);

  const exportData = getExportData(data, tableHeaders, visibleHeaders);

  return (
    <div className="space-y-4">
      <div className="hidden sm:block">
        <FilterComponent
          fields={filterFields}
          onApply={handleApplyFilters}
          onReset={handleResetFilters}
        />
      </div>
      <SearchExportComponent
        exportFileName="DistributorSales"
        onSearch={handleSearch}
        // onExport={handleExport}
        searchPlaceholder="Search Distributor Sales..."
        tablefields={tableHeaders}
        selectedHeaders={visibleHeaders}
        onHeadersChange={setVisibleHeaders}
        fields={filterFields}
        onApply={handleApplyFilters}
        onReset={handleResetFilters}
        exportData={exportData} //FIXME:
      />

      <SalesTable
        data={data}
        loading={loading}
        headers={tableHeaders.filter((header) =>
          visibleHeaders.includes(header.value)
        )}
        handleViewAction={handleViewAction}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
    </div>
  );
};

export default DistributorSale;
